module.exports = __webpack_public_path__ + "assets/img/Bestpartner.f268484d.png";